// extracted by mini-css-extract-plugin
module.exports = {"new-content":"content_new-content__86o2D","outer-list":"content_outer-list__K_0V7","inner-list":"content_inner-list__deapX"};